/**
 * Prefetch debug logging utility.
 *
 * Gated by the unified perf flag (lib/perf/perfFlag.ts): `?ahoy_perf=1`,
 * `localStorage['ahoy:perf'] = '1'`, or the legacy `debug_prefetch = '1'` key.
 *
 * All output goes to console.warn (allowed by eslint no-console rule).
 */

import { isPerfTraceEnabled } from '@/lib/perf/perfFlag';

function isEnabled(): boolean {
  return isPerfTraceEnabled();
}

/**
 * Returns true if prefetch debug logging is currently enabled.
 * Use this to gate expensive debug-only computations at the call site.
 */
export function isPrefetchDebugEnabled(): boolean {
  return isEnabled();
}

/**
 * Log a prefetch debug message. No-op unless the perf flag is on.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function prefetchDebug(label: string, data?: Record<string, any>): void {
  if (!isEnabled()) {
    return;
  }
  if (data) {
    console.warn(`[prefetch:debug] ${label}`, data);
  } else {
    console.warn(`[prefetch:debug] ${label}`);
  }
}
